var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.label)?_c('div',{staticClass:"c-content-top"},[_c('div',{staticClass:"left"},[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"right"},[_vm._t("right")],2)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }